import { AppState } from 'app/store';

export const getPlaylistService = (state: AppState) =>
  state.auth.services?.playlists;

export const getCreatePlaylistLink = (state: AppState) =>
  state.auth.services?.playlists?._links?.createPlaylist;

export const getFetchPlaylistLink = (state: AppState) =>
  state.auth.services?.playlists?._links?.getPlaylist;

export const getDeletePlaylistAudioLink = (state: AppState) =>
  state.playlists.playlist?._links.deletePlaylistAudio;

export const getCreatePlaylistAudioLink = (state: AppState) =>
  state.playlists.playlist?._links.createPlaylistAudio;

export const getCreatePlaylistAudioTemplatedLink = (state: AppState) =>
  state.playlists._links?.createPlaylistAudio;

export const getPlaylistAddingAudiosLoadingState = (state: AppState) =>
  state.playlists.addingAudiosLoadingState;

export const getPlaylist = (state: AppState) => state.playlists.playlist;

export const getPlaylistsListLink = (appState: AppState) =>
  appState.auth.services?.playlists?._links?.listPlaylists;

export const getPlaylistsList = (appState: AppState) =>
  appState.playlists.playlists;

export const getPlaylistsNextLink = (appState: AppState) =>
  appState.playlists?._links?.next;

export const getPatchPlaylistLink = (appState: AppState) =>
  appState.playlists.playlist?._links.patchPlaylist;

export const getMovePlaylistAudioLink = (appState: AppState) =>
  appState.playlists.playlist?._links.movePlaylistAudio;

export const getUpdatePlaylistAudioLink = (appState: AppState) =>
  appState.playlists.playlist?._links.updatePlaylistAudio;

export const getPlaylistAudiosLink = (appState: AppState) =>
  appState.playlists.playlist?._links.updatePlaylistAudio;

export const getDeletePlaylistLink = (appState: AppState) =>
  appState.playlists?._links?.deletePlaylist;

export const getUploadPlaylistImageLink = (appState: AppState) =>
  appState.playlists.playlist?._links.uploadPlaylistImage;

export const getDeletePlaylistImageLink = (appState: AppState) =>
  appState.playlists.playlist?._links.deletePlaylistImage;

export const getPlaylistImageUploadStatusLink = (appState: AppState) =>
  appState.playlists.imageUploadStatusLink;

export const getPlaylistHeaderImage = (appState: AppState) =>
  appState.playlists.playlist?.images.find(
    (image) => image.name === 'playlist-tiny'
  )?.href;
